import * as v from "valibot";
import { AuthorStatus } from "../../models/author";
import { aliasField, imageDto, influenceDto, levelDto } from "../shared.dto";

export const AUTHOR_STATUSES: AuthorStatus[] = Object.values(AuthorStatus);

const authorStatusDto = v.picklist(AUTHOR_STATUSES);

const writingStyleDto = v.object({
  inspiredBy: influenceDto,
  tone: v.string(),
  humorous: v.boolean(),
  vocabulary: v.string(),
  explanation: v.string(),
  sentenceStructure: v.string(),
  exampleUsage: v.string(),
  introductionStyle: v.string(),
  conclusionStyle: v.string(),
});

/** An author as the admin sees them: the whole row, status and writing style included. */
export const adminAuthorDto = v.object({
  alias: v.string(),
  expertise: v.object({ category: v.string(), subcategory: v.string(), subjects: v.array(v.string()) }),
  tagline: v.string(),
  perspective: v.string(),
  mission: v.string(),
  about: v.array(v.string()),
  targetAudience: v.object({ expertise: levelDto, description: v.string() }),
  influencedBy: influenceDto,
  writingStyle: writingStyleDto,
  aiModel: v.string(),
  status: authorStatusDto,
  profileImage: v.optional(imageDto),
  followerCount: v.number(),
  publishedArticleCount: v.number(),
  createdAt: v.number(),
  updatedAt: v.number(),
});
export type AdminAuthor = v.InferOutput<typeof adminAuthorDto>;

export const listAdminAuthorsRequest = {
  status: v.optional(authorStatusDto),
};

export const listAdminAuthorsResponse = {
  authors: v.array(adminAuthorDto),
  /** Authors per status, whatever the filter. */
  counts: v.record(v.string(), v.number()),
};

export const adminAuthorKey = { alias: aliasField };

export const getAdminAuthorResponse = { author: adminAuthorDto };

export const updateAdminAuthorImageRequest = {
  alias: aliasField,
  imageId: v.pipe(v.string(), v.minLength(1), v.maxLength(64)),
  /** The stock image's URL with a crop rectangle, when the admin cropped it. */
  imageCropUrl: v.optional(v.pipe(v.string(), v.maxLength(1024))),
};

export const adminStatsSummaryDto = v.object({ period: v.picklist(["day", "week", "month"]), viewCount: v.number(), readCount: v.number() });
export type AdminStatsSummary = v.InferOutput<typeof adminStatsSummaryDto>;

export const getAdminAuthorStatsResponse = { stats: v.array(adminStatsSummaryDto) };
